<template>
  <div class="ts-space-y-3">
    <div class="ts-flex ts-justify-between">
      <a-radio-group
        :default-value="2"
        button-style="solid"
        v-model="approveStatusId"
        @change="fetchData()"
      >
        <a-radio-button
          v-for="(status, index) in approveStatus"
          :key="index"
          :value="status.value"
        >
          {{ status.label }}
        </a-radio-button>
      </a-radio-group>
      <ts-input
        v-tooltip="$t('approvalRequest.search')"
        v-model="search"
        :placeholder="$t('search')"
        style="width: 250px;"
        class="inline-block"
      />
    </div>
    <ts-loading-banner :loading="loading">
      <table class="ts-w-full">
        <thead>
          <tr class="ts-bg-gray-200">
            <th
              class="ts-text-center ts-w-2 ts-px-3 ts-py-1 ts-uppercase ts-top-0 ts-sticky"
              valign="middle"
            >
              #
            </th>
            <th class="ts-px-3 ts-py-1 ts-uppercase ts-top-0 ts-sticky">
              {{ $t('approvalRequest.planDate') }}
            </th>
            <th class="ts-px-3 ts-py-1 ts-uppercase ts-top-0 ts-sticky">
              {{ $t('approvalRequest.dealerCode') }}
            </th>
            <th class="ts-px-3 ts-py-1 ts-uppercase ts-top-0 ts-sticky">
              {{ $t('approvalRequest.dealerName') }}
            </th>
            <th class="ts-px-3 ts-py-1 ts-uppercase ts-top-0 ts-sticky">
              {{ $t('approvalRequest.dealerContactNumber') }}
            </th>
            <th class="ts-px-3 ts-py-1 ts-uppercase ts-top-0 ts-sticky">
              {{ $t('approvalRequest.requestBy') }}
            </th>
            <th class="ts-px-3 ts-py-1 ts-uppercase ts-top-0 ts-sticky">
              {{ $t('approvalRequest.reason') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="ts-border-b"
            v-for="(r, index) in shopHistoryResources"
            :key="index"
          >
            <td class="ts-px-3 ts-py-1 ts-text-center">{{ index + 1 }}</td>
            <td class="ts-px-3 ts-py-1">{{ r.plan_date }}</td>
            <td class="ts-px-3 ts-py-1">{{ r.customer_code }}</td>
            <td class="ts-px-3 ts-py-1">{{ r.customer_name }}</td>
            <td class="ts-px-3 ts-py-1">{{ r.contact_number }}</td>
            <td class="ts-px-3 ts-py-1">{{ r.request_by_name }}</td>
            <td class="ts-px-3 ts-py-1">{{ r.reason }}</td>
          </tr>
        </tbody>
      </table>
            <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="shopHistoryPagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-loading-banner>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'shopHistory',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('hr/approvalRequest', [
      'shopHistoryPagination',
      'shopHistoryResources'
    ]),
    approveStatus() {
      return [
        { value: 2, label: 'Approved' },
        { value: 1, label: 'Partially Approved' },
        { value: 3, label: 'Rejected' }
      ]
    },
    search: {
      get() {
        return this.$store.state.hr.approvalRequest.shop_history_search
      },
      set(newValue) {
        this.$store.commit(
          'hr/approvalRequest/SET_SHOP_HISTORY_SEARCH',
          newValue
        )
        this.$store.commit('hr/approvalRequest/RESET_CURRENT_PAGE')
      }
    },
    approveStatusId: {
      get() {
        return this.$store.state.hr.approvalRequest.approve_shop_history_status
      },
      set(newValue) {
        this.$store.commit(
          'hr/approvalRequest/SET_APPROVE_SHOP_HISTORY_STATUS',
          newValue
        )
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(attributes = {}) {
      this.loading = true
      this.$store
        .dispatch('hr/approvalRequest/fetchReCheckInHistory', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500)
  }
}
</script>
